import { render, staticRenderFns } from "./Rotator1.vue?vue&type=template&id=710cb2cb&scoped=true"
import script from "./Rotator1.vue?vue&type=script&lang=js"
export * from "./Rotator1.vue?vue&type=script&lang=js"
import style0 from "./Rotator1.vue?vue&type=style&index=0&id=710cb2cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710cb2cb",
  null
  
)

export default component.exports